import { Component } from '@angular/core';

import { TranslationKeyMap } from '../gp-main.i18n';

@Component({
    selector: 'cmps-gp-no-action',
    templateUrl: './no-action.component.html',
})
export class NoActionComponent {
    /** @private */
    _i18n = TranslationKeyMap;
}
